!function (t, e) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = e(require("react"));else if ("function" == typeof define && define.amd) define(["react"], e);else {
    var n = "object" == typeof exports ? e(require("react")) : e(t.react);
    for (var r in n) ("object" == typeof exports ? exports : t)[r] = n[r];
  }
}(window, function (t) {
  return function (t) {
    var e = {};
    function n(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) n.d(r, o, function (e) {
        return t[e];
      }.bind(null, o));
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 2);
  }([function (e, n) {
    e.exports = t;
  }, function (t, e, n) {
    (function (e) {
      var n = "Expected a function",
        r = NaN,
        o = "[object Symbol]",
        i = /^\s+|\s+$/g,
        u = /^[-+]0x[0-9a-f]+$/i,
        c = /^0b[01]+$/i,
        a = /^0o[0-7]+$/i,
        l = parseInt,
        f = "object" == typeof e && e && e.Object === Object && e,
        s = "object" == typeof self && self && self.Object === Object && self,
        d = f || s || Function("return this")(),
        p = Object.prototype.toString,
        y = Math.max,
        h = Math.min,
        m = function m() {
          return d.Date.now();
        };
      function b(t, e, r) {
        var o,
          i,
          u,
          c,
          a,
          l,
          f = 0,
          s = !1,
          d = !1,
          p = !0;
        if ("function" != typeof t) throw new TypeError(n);
        function b(e) {
          var n = o,
            r = i;
          return o = i = void 0, f = e, c = t.apply(r, n);
        }
        function w(t) {
          var n = t - l;
          return void 0 === l || n >= e || n < 0 || d && t - f >= u;
        }
        function O() {
          var t = m();
          if (w(t)) return j(t);
          a = setTimeout(O, function (t) {
            var n = e - (t - l);
            return d ? h(n, u - (t - f)) : n;
          }(t));
        }
        function j(t) {
          return a = void 0, p && o ? b(t) : (o = i = void 0, c);
        }
        function A() {
          var t = m(),
            n = w(t);
          if (o = arguments, i = this, l = t, n) {
            if (void 0 === a) return function (t) {
              return f = t, a = setTimeout(O, e), s ? b(t) : c;
            }(l);
            if (d) return a = setTimeout(O, e), b(l);
          }
          return void 0 === a && (a = setTimeout(O, e)), c;
        }
        return e = g(e) || 0, v(r) && (s = !!r.leading, u = (d = "maxWait" in r) ? y(g(r.maxWait) || 0, e) : u, p = "trailing" in r ? !!r.trailing : p), A.cancel = function () {
          void 0 !== a && clearTimeout(a), f = 0, o = l = i = a = void 0;
        }, A.flush = function () {
          return void 0 === a ? c : j(m());
        }, A;
      }
      function v(t) {
        var e = typeof t;
        return !!t && ("object" == e || "function" == e);
      }
      function g(t) {
        if ("number" == typeof t) return t;
        if (function (t) {
          return "symbol" == typeof t || function (t) {
            return !!t && "object" == typeof t;
          }(t) && p.call(t) == o;
        }(t)) return r;
        if (v(t)) {
          var e = "function" == typeof t.valueOf ? t.valueOf() : t;
          t = v(e) ? e + "" : e;
        }
        if ("string" != typeof t) return 0 === t ? t : +t;
        t = t.replace(i, "");
        var n = c.test(t);
        return n || a.test(t) ? l(t.slice(2), n ? 2 : 8) : u.test(t) ? r : +t;
      }
      t.exports = function (t, e, r) {
        var o = !0,
          i = !0;
        if ("function" != typeof t) throw new TypeError(n);
        return v(r) && (o = "leading" in r ? !!r.leading : o, i = "trailing" in r ? !!r.trailing : i), b(t, e, {
          leading: o,
          maxWait: e,
          trailing: i
        });
      };
    }).call(this, n(3));
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0),
      o = n.n(r),
      i = n(1),
      u = n.n(i);
    function c(t) {
      return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }
    function a(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function l(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? a(Object(n), !0).forEach(function (e) {
          m(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    function f(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }
    function s(t, e) {
      return (s = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }
    function d(t, e) {
      return !e || "object" !== c(e) && "function" != typeof e ? p(t) : e;
    }
    function p(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function y() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }
    function h(t) {
      return (h = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }
    function m(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }
    var b = function b(t, e) {
        window.addEventListener ? window.addEventListener(t, e) : window.attachEvent("on" + t, e);
      },
      v = function v(t) {
        if (t) {
          var e = t.getBoundingClientRect();
          return e.top >= 0 && e.left >= 0 && e.top <= (window.innerHeight || document.documentElement.clientHeight) && e.left <= (window.innerWidth || document.documentElement.clientWidth);
        }
      },
      g = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && s(t, e);
        }(g, r["Component"]);
        var e,
          n,
          i,
          c,
          a = (e = g, function () {
            var t,
              n = h(e);
            if (y()) {
              var r = h(this).constructor;
              t = Reflect.construct(n, arguments, r);
            } else t = n.apply(this, arguments);
            return d(this, t);
          });
        function g(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, g), m(p(e = a.call(this, t)), "lazyLoad", function () {
            v(e.imageRef) && (e.clearEventListeners(), e.loadImage());
          }), m(p(e), "setImageRef", function (t) {
            e.imageRef = t;
          }), e._isMounted = !1, e.throttledFunction = u()(e.lazyLoad, 150), e.state = {
            loaded: !1,
            retryDelay: e.props.retry.delay,
            retryCount: 1
          }, e;
        }
        return n = g, (i = [{
          key: "addAnimationStyles",
          value: function value() {
            if (!document.head.querySelectorAll("[data-gracefulimage]").length) {
              var t = document.createElement("style");
              t.setAttribute("data-gracefulimage", "exists"), document.head.appendChild(t), t.sheet.insertRule("\n  @keyframes gracefulimage {\n    0%   { opacity: 0.25; }\n    50%  { opacity: 0.5; }\n    100% { opacity: 1; }\n  }\n", t.sheet.cssRules.length);
            }
          }
        }, {
          key: "setLoaded",
          value: function value() {
            this._isMounted && this.setState({
              loaded: !0
            }, this.props.onLoad);
          }
        }, {
          key: "loadImage",
          value: function value() {
            var t = this,
              e = new Image();
            e.onload = function () {
              t.setLoaded();
            }, e.onerror = function () {
              t.handleImageRetries(e);
            }, e.src = this.props.src;
          }
        }, {
          key: "componentDidMount",
          value: function value() {
            this._isMounted = !0, this.addAnimationStyles(), this.props.noLazyLoad ? this.loadImage() : v(this.imageRef) ? this.loadImage() : (b("load", this.throttledFunction), b("scroll", this.throttledFunction), b("resize", this.throttledFunction), b("gestureend", this.throttledFunction));
          }
        }, {
          key: "clearEventListeners",
          value: function value() {
            this.throttledFunction.cancel(), window.removeEventListener("load", this.throttledFunction), window.removeEventListener("scroll", this.throttledFunction), window.removeEventListener("resize", this.throttledFunction), window.removeEventListener("gestureend", this.throttledFunction);
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this._isMounted = !1, this.timeout && window.clearTimeout(this.timeout), this.clearEventListeners();
          }
        }, {
          key: "handleImageRetries",
          value: function value(t) {
            var e = this,
              n = this.props,
              r = n.src,
              o = n.retry,
              i = o.count,
              u = o.delay,
              c = o.accumulate,
              a = n.onError,
              l = this.state,
              f = l.retryCount,
              s = l.retryDelay;
            this._isMounted && this.setState({
              loaded: !1
            }, function () {
              f <= i ? e.timeout = setTimeout(function () {
                e._isMounted && (t.src = r, e.setState(function (t) {
                  return {
                    retryDelay: "multiply" === c ? t.retryDelay * u : "add" === c ? t.retryDelay + u : u,
                    retryCount: t.retryCount + 1
                  };
                }));
              }, 1e3 * s) : a();
            });
          }
        }, {
          key: "render",
          value: function value() {
            var t = this.props,
              e = t.src,
              n = t.noPlaceholder,
              r = t.placeholderColor,
              i = t.srcSet,
              u = t.className,
              c = t.width,
              a = t.height,
              f = t.style,
              s = t.alt,
              d = t.customPlaceholder,
              p = this.state.loaded,
              y = p ? e : "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
              h = p ? {
                animationName: "gracefulimage",
                animationDuration: "0.3s",
                animationIterationCount: 1,
                animationTimingFunction: "ease-in"
              } : {
                background: r
              };
            return !p && n ? null : !p && d ? d(this.setImageRef) : o.a.createElement("img", {
              src: y,
              srcSet: i,
              className: u,
              width: c,
              height: a,
              style: l({}, h, {}, f),
              alt: s,
              ref: this.setImageRef
            });
          }
        }]) && f(n.prototype, i), c && f(n, c), g;
      }();
    g.defaultProps = {
      placeholderColor: "#eee",
      retry: {
        count: 8,
        delay: 2,
        accumulate: "multiply"
      },
      customPlaceholder: null,
      noPlaceholder: !1,
      noLazyLoad: !1,
      onLoad: function onLoad() {},
      onError: function onError() {}
    }, e.default = g;
  }, function (t, e) {
    var n;
    n = function () {
      return this;
    }();
    try {
      n = n || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (n = window);
    }
    t.exports = n;
  }]);
});